export var PRINT_FULL_HEIGHT = 815;
export var PRINT_FULL_WIDTH = 1152;
export var PRINT_IMG_CAPTION_HEIGHT = PRINT_FULL_HEIGHT - 40;
//# sourceMappingURL=printConst.js.mapexport var PRINT_FULL_HEIGHT = 815;
export var PRINT_FULL_WIDTH = 1152;
export var PRINT_IMG_CAPTION_HEIGHT = PRINT_FULL_HEIGHT - 40;
//# sourceMappingURL=printConst.js.map